import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";

export default function Astrologers() {
  const [astrologers, setAstrologers] = useState([]);

  const fetchAstrologers = async () => {
    const snap = await getDocs(collection(db, "astrologers"));
    setAstrologers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => { fetchAstrologers(); }, []);

  const approveAstrologer = async (id, currentStatus) => {
    await updateDoc(doc(db, "astrologers", id), { status: currentStatus === "approved" ? "pending" : "approved" });
    fetchAstrologers();
  };

  const deleteAstrologer = async (id) => {
    await deleteDoc(doc(db, "astrologers", id));
    fetchAstrologers();
  };

  return (
    <div>
      <h1>🔮 Astrologers</h1>
      <div className="card">
        <table width="100%">
          <thead>
            <tr>
              <th>Name</th><th>Phone</th><th>Status</th><th>Rate/min</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {astrologers.map((a) => (
              <tr key={a.id}>
                <td>{a.name}</td>
                <td>{a.phone}</td>
                <td style={{ color: a.status === "approved" ? "lightgreen" : "orange" }}>{a.status}</td>
                <td>₹{a.ratePerMinChat || 0}</td>
                <td>
                  <button onClick={() => approveAstrologer(a.id, a.status)}>
                    {a.status === "approved" ? "Revoke" : "Approve"}
                  </button>
                  <button onClick={() => deleteAstrologer(a.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}